import { useEffect } from "react";

import {
  useChatSettingsStore,
  type ChatSettingsState,
} from "@/features/tutor/store/useChatSettingsStore";
import { useRuntimeContext } from "@/features/tutor/context/RuntimeContext";

export interface GainPlayer {
  volume: (value: number) => void;
}

type GetPlayer = () => GainPlayer | null | undefined;

export const selectTutorAudible = (
  state: Pick<ChatSettingsState, "tutorAudioOn" | "effectiveTutorAudioOn">,
): boolean => state.tutorAudioOn && state.effectiveTutorAudioOn;

export const applyTutorGain = (
  getPlayer: GetPlayer,
  tutorAudioOn: boolean,
): void => {
  getPlayer()?.volume(tutorAudioOn ? 1 : 0);
};

export const useTutorAudioGain = () => {
  const audible = useChatSettingsStore(selectTutorAudible);
  const { pcmPlayerRef } = useRuntimeContext() ?? {};

  useEffect(() => {
    applyTutorGain(() => pcmPlayerRef?.current ?? window.pcmPlayer, audible);
  }, [pcmPlayerRef, audible]);
};
